import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, isRef as _isRef, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9e68b5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "apply-wrap" }
const _hoisted_2 = { class: "step" }
const _hoisted_3 = { class: "apply-view-wrap" }
const _hoisted_4 = { class: "tip-show-wrap" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip-show-text" }, [
  /*#__PURE__*/_createElementVNode("div", null, " 本人确认，本人申请补办合格证/铭牌/拓印牌等资料的设备为本人所有，所提交给贵司的资料及信息均为真实、有效的。 "),
  /*#__PURE__*/_createElementVNode("div", null, " 本人承诺，不会将补办的合格证/铭牌/拓印牌等资料用于任何非法用途，否则由此产生的一切后果（包括给极飞科技造成的损失）均由本人承担。 ")
], -1))
const _hoisted_6 = { class: "comfirm-buttom xag-page__footer" }
const _hoisted_7 = {
  key: 0,
  class: "bottom-tip"
}
const _hoisted_8 = { class: "button-wrap" }

import Step from './components/header-step.vue'
import AppHeader from '@/components/Header.vue'
import FillInEquipment from './components/fill-in-equipment.vue'
import FillInApplyInfo from './components/fill-in-apply-info.vue'
import CommonFooterWrap from '@/components/CommonFooterWrap.vue'
import { Button, CheckboxGroup, Checkbox } from 'vant'
import { ref, computed, onMounted, onDeactivated } from 'vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'
import PopCommonWrap from '@/components/popup/common-wrap.vue'
import { useRoute, useRouter } from 'vue-router'
import { commonErrorHandle } from '@/utils/error-handle'
import { clearToast, showToastFail, showToastLoading } from '@/utils/tools'
import {
  confirmNameplateReissue,
  getNameplateReissueDetail,
  reConfirmNameplateReissue,
  validateGroundStation,
} from '@/apis/nameplate-reissue'


import { defineComponent } from 'vue'
import { NameplateReissueApply } from '@/store/nameplate-reissue'
import { useStore } from 'vuex'
const __default__ = defineComponent({
  name: 'nameplate-reissue-apply',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let tipShow = ref(false)
let isConfirmRead = ref([])
let isFillInEquipmentCanNext = ref(false)
let isFillInApplyInfoCanNext = ref(false)
const $router = useRouter()
const $route = useRoute()

onDeactivated(() => {
  clearToast()
})

const guid = computed(() => {
  return $route.query.guid
})
let stepData = ref([
  {
    status: '填写设备信息',
  },
  {
    status: '填写申请说明',
  },
  {
    status: '确认提交信息',
  },
])
let stepActive = ref(1)
let isCanConfirm = computed(() => {
  if (stepActive.value === 2) {
    return isFillInApplyInfoCanNext.value
  } else {
    return true
  }
})

let confirmBtnText = computed(() => {
  if (stepActive.value === 2) {
    return '提交申请'
  } else {
    return '确认提交'
  }
})
const fillInEquipmentRef = ref<InstanceType<typeof FillInEquipment>>()
const fillInApplyInfoRef = ref<InstanceType<typeof FillInApplyInfo>>()
async function nextHandler() {
  if (stepActive.value === 3) {
    tipShow.value = true
  } else {
    if (stepActive.value === 1) {
      // 校验地面站编码
      let fillInEquipmentData = fillInEquipmentRef.value.getParams()
      if (fillInEquipmentData.ground_station_no) {
        try {
          showToastLoading({
            message: '校验中...',
          })
          let data = await validateGroundStation(fillInEquipmentData.ground_station_no)
          console.log('data', data)
          clearToast()
          if (!data) {
            showToastFail('地面站（单控）编码不存在！')
            return
          }
        } catch (e) {
          clearToast()
        }
      }
    }

    stepActive.value = stepActive.value + 1
  }
}
function preHandler() {
  stepActive.value = stepActive.value - 1
}
async function confirmHandler() {
  try {
    showToastLoading()
    // 获取参数
    let data
    if (!guid.value) {
      data = await confirmNameplateReissue({
        ...fillInEquipmentRef.value.getParams(),
        ...fillInApplyInfoRef.value.getParams(),
      })
    } else {
      // 重新提交
      data = await reConfirmNameplateReissue(
        {
          ...fillInEquipmentRef.value.getParams(),
          ...fillInApplyInfoRef.value.getParams(),
        },
        guid.value as string
      )
    }
    clearToast()
    $router.replace({
      name: 'nameplate-confirm-success',
      query: {
        guid: data.guid,
      },
    })
  } catch (e) {
    clearToast()
    // if (guid.value) {
    //   showToastFail(e as string)
    // }
    commonErrorHandle(e)
    // console.log(e)
  }
}
const isConfirmSumitStatus = computed(() => stepActive.value === 3)
// 回填数据
async function init() {
  if (guid.value) {
    // 重新提交
    // 设置状态为确认提交信息
    try {
      showToastLoading()
      stepActive.value = 3
      let detailData = await getNameplateReissueDetail(guid.value as string)
      fillInEquipmentRef.value.setData({
        serial_number: detailData.serial_number,
        apply_namplate_types: detailData.apply_namplate_types,
        namplate_types: detailData.namplate_types,
        namplate_types_text: detailData.namplate_types_text,
        product_models: detailData.product_models,
        flight_control_no: detailData.flight_control_no,
        ground_station_no: detailData.ground_station_no,
        factory_at: detailData.factory_at,
        model_type: detailData.model_type,
        product_model: detailData.product_model,
      })
      await fillInApplyInfoRef.value.setData({
        currentReason: detailData.reason_type,
        pageReason: detailData.reason_type,
        reason_type_text: detailData.reason_type_text,
        reason: detailData.reason,
        description: detailData.description,
        images: detailData.images,
        files: detailData.files,
        receiptInfo: {
          name: detailData.receive_express.name,
          tel: detailData.receive_express.phone,
          province: detailData.receive_express.province,
          city: detailData.receive_express.city,
          county: detailData.receive_express.area,
          addressDetail: detailData.receive_express.address,
          areaCode: detailData.receive_express.areaCode,
        },
      })
      clearToast()
    } catch (e) {
      clearToast()
      showToastFail(e as string)
      console.log(e)
    }
  }
}
const $store = useStore()
onMounted(() => {
  $store.commit('NameplateReissue/addCacheRouteName', NameplateReissueApply)
  init()
})

const isShowBtn = computed(() => {
  return (
    !fillInEquipmentRef.value?.snActionShow &&
    !fillInEquipmentRef.value?.reissueTypeShow &&
    !fillInEquipmentRef.value?.productNumberActionShow
  )
})
const isHideStep = computed(() => {
  return (
    !fillInEquipmentRef.value?.snActionShow &&
    !fillInEquipmentRef.value?.reissueTypeShow &&
    !fillInApplyInfoRef.value?.applyReasonActionShow
  )
})
const isShowBtn2 = computed(() => {
  return !fillInApplyInfoRef.value?.applyReasonActionShow && !tipShow.value
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "三证补办申请" }),
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        _createVNode(Step, {
          stepData: _unref(stepData),
          stepActive: _unref(stepActive)
        }, null, 8, ["stepData", "stepActive"])
      ], 512), [
        [_vShow, _unref(isHideStep)]
      ]),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createVNode(FillInEquipment, {
          isCanNext: _unref(isFillInEquipmentCanNext),
          "onUpdate:isCanNext": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isFillInEquipmentCanNext) ? (isFillInEquipmentCanNext).value = $event : isFillInEquipmentCanNext = $event)),
          isEdit: !_unref(isConfirmSumitStatus),
          ref_key: "fillInEquipmentRef",
          ref: fillInEquipmentRef
        }, null, 8, ["isCanNext", "isEdit"]), [
          [_vShow, _unref(stepActive) === 1 || _unref(stepActive) === 3]
        ]),
        _withDirectives(_createVNode(FillInApplyInfo, {
          isCanNext: _unref(isFillInApplyInfoCanNext),
          "onUpdate:isCanNext": _cache[1] || (_cache[1] = ($event: any) => (_isRef(isFillInApplyInfoCanNext) ? (isFillInApplyInfoCanNext).value = $event : isFillInApplyInfoCanNext = $event)),
          isEdit: !_unref(isConfirmSumitStatus),
          guid: (_unref(guid) as string),
          style: _normalizeStyle({ marginTop: _unref(stepActive) === 3 ? '10px' : '0' }),
          ref_key: "fillInApplyInfoRef",
          ref: fillInApplyInfoRef
        }, null, 8, ["isCanNext", "isEdit", "guid", "style"]), [
          [_vShow, _unref(stepActive) === 2 || _unref(stepActive) === 3]
        ])
      ]),
      _createVNode(PopCommonWrap, {
        show: _unref(tipShow),
        "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (_isRef(tipShow) ? (tipShow).value = $event : tipShow = $event)),
        title: "温馨提示",
        style: { height: '60vh' },
        class: "pop-wrap",
        headerStyle: { display: 'flex', justifyContent: 'center' },
        showHeaderClose: false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_unref(CheckboxGroup), {
                  modelValue: _unref(isConfirmRead),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(isConfirmRead) ? (isConfirmRead).value = $event : isConfirmRead = $event)),
                  "checked-color": "rgba(0, 195, 120, 1)"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Checkbox), {
                      name: true,
                      shape: "square"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("我知道了")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_unref(Button), {
                  class: "confirm-button",
                  disabled: !_unref(isConfirmRead).length,
                  onClick: confirmHandler
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("确认提交")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    (_unref(stepActive) === 1 && _unref(isShowBtn))
      ? (_openBlock(), _createBlock(CommonFooterNextButton, {
          key: 0,
          title: "下一步",
          disabled: !_unref(isFillInEquipmentCanNext),
          onClick: nextHandler
        }, null, 8, ["disabled"]))
      : _createCommentVNode("", true),
    (_unref(stepActive) !== 1 && _unref(isShowBtn2))
      ? (_openBlock(), _createBlock(CommonFooterWrap, { key: 1 }, {
          default: _withCtx(() => [
            (_unref(stepActive) === 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, "* 请核对以上信息并确认无误！"))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_unref(Button), {
                class: "pre-button xa-vant-button",
                round: "",
                onClick: preHandler
              }, {
                default: _withCtx(() => [
                  _createTextVNode("返回修改")
                ]),
                _: 1
              }),
              _createVNode(_unref(Button), {
                class: _normalizeClass(["next-button xa-vant-button", { 'is-can-confrim': _unref(isCanConfirm) }]),
                round: "",
                onClick: nextHandler,
                disabled: !_unref(isCanConfirm)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(confirmBtnText)), 1)
                ]),
                _: 1
              }, 8, ["class", "disabled"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})